import { LOGS_PAGINATION_CHANGE } from "../../constants";
export const logsPaginationChange = (page) => {
  return {
    type: LOGS_PAGINATION_CHANGE,
    payload: page,
  };
};
